var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 48095670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M14.5219 3.5625C11.2246 3.5625 10.8121 6.2985 10.8121 6.2985C10.8121 6.2985 10.401 3.5625 7.10374 3.5625C3.93244 3.5625 3.00836 6.8955 3.39539 8.6775C4.41549 13.3875 10.8121 16.6875 10.8121 16.6875C10.8121 16.6875 17.2101 13.3875 18.2302 8.6775C18.6158 6.8955 17.6902 3.5625 14.5219 3.5625Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.796f6dd3a37fb039d1231a37dfe18d7e.svg";
export { ForwardRef as ReactComponent };